import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';

import * as Api from '../../api/api';

export const linkReferralToEmployee = (
  orgId: number,
  referralId: number,
  referringEmployeeId: number,
) =>
  createGenericDispatcher({
    name: 'LINK_REFERRAL_TO_EMPLOYEE',
    loadFunction: () =>
      Api.post(`/referral/${referralId}/link`, {
        body: JSON.stringify({ referringEmployeeId }),
      }),
    args: { orgId, referralId, referringEmployeeId },
    onSuccess: (dispatch) => {
      dispatch(
        addNotificationAction({
          key: `link-referral-${referralId}-to-employee-${referringEmployeeId}`,
          message: 'Linked referral to employee',
        }),
      );
    },
  });
